<ng-container *ngLet="filter$ | async as filter">
  <app-toolbar *transloco="let t; read: 'ime.common.properties'">
    <app-breadcrumbs>
    </app-breadcrumbs>
    <app-page-search class="me-auto" [(searchString)]="filter.Global" [(showFilters)]="filter.AdvancedFilter" (searchStringChange)="filter$.next(filter)"></app-page-search>
    <app-toolbar-list-buttons [showAdd]="PRIVILEGES.EditCommonData | userHasPrivilege" (addClick)="add()">
      <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="downloadExcel()">
        <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#table-cells'">
        </svg>
        {{t('Export')}}
      </button>
    </app-toolbar-list-buttons>
  </app-toolbar>
  <p-table styleClass="p-datatable-sm p-datatable-striped"
           [value]="properties$ | async"
           sortField="Code"
           dataKey="Id"
           [paginator]="true"
           [rows]="50"
           [rowsPerPageOptions]="[10,25,50,100,200]"
           [showCurrentPageReport]="true"
           currentPageReportTemplate="{first} to {last} of {totalRecords}"
           [globalFilterFields]="['Code', 'Name', 'Sequence']">
    <ng-template pTemplate="header">
      <ng-container *transloco="let t; read: 'ime.common.properties'">
        <tr>
          <th pSortableColumn="Code">
            {{t('Code')}}
            <p-sortIcon field="Code"></p-sortIcon>
          </th>
          <th pSortableColumn="Name">
            {{t('Name')}}
            <p-sortIcon field="Name"></p-sortIcon>
          </th>
          <th pSortableColumn="Sequence">
            {{t('Sequence')}}
            <p-sortIcon field="Sequence"></p-sortIcon>
          </th>
          <th pSortableColumn="GroupClv">
            {{t('Group')}}
            <p-sortIcon field="GroupClv"></p-sortIcon>
          </th>
          <th pSortableColumn="TypeClv">
            {{t('Type')}}
            <p-sortIcon field="TypeClv"></p-sortIcon>
          </th>
          <th pSortableColumn="ChoiceTypeClassificatorId">
            {{t('Choice Type')}}
            <p-sortIcon field="ChoiceTypeClassificatorId"></p-sortIcon>
          </th>
          <th pSortableColumn="UnitId">
            {{t('Unit')}}
            <p-sortIcon field="UnitId"></p-sortIcon>
          </th>
        </tr>

        <tr *ngIf="filter.AdvancedFilter">
          <th colspan="3"></th>
          <th class="p-1">
            <ng-select #select class="select-sm form-control" [items]="classificatorValuesQuery.propertyGroups$ | async" [(ngModel)]="filter.Data.GroupClv"
                       bindLabel="DisplayName" bindValue="Id" appendTo="body" (change)="filter$.next(filter); select.close()">
            </ng-select>
          </th>
          <th class="p-1">
            <ng-select #select class="select-sm form-control" [items]="classificatorValuesQuery.propertyTypes$ | async" [(ngModel)]="filter.Data.TypeClv"
                       bindLabel="DisplayName" bindValue="Id" appendTo="body" (change)="filter$.next(filter); select.close()">
            </ng-select>
          </th>
          <th class="p-1">
            <ng-select #select class="select-sm form-control" [items]="classificatorsQuery.getAll$ | async" [(ngModel)]="filter.Data.ChoiceTypeClassificatorId"
                       bindLabel="DisplayName" bindValue="Id" appendTo="body" (change)="filter$.next(filter); select.close()">
            </ng-select>
          </th>
          <th class="p-1">
            <ng-select #select class="select-sm form-control" [items]="unitService.getAll$ | async" [(ngModel)]="filter.Data.UnitId"
                       bindLabel="DisplayName" bindValue="Id" appendTo="body" (change)="filter$.next(filter); select.close()">
            </ng-select>
          </th>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="body" let-property>
      <tr>
        <td class="text-wrap text-break"><a href [routerLink]="['edit', property.Id]">{{property.Code}}</a></td>
        <td class="text-wrap text-break"><a href [routerLink]="['edit', property.Id]">{{property.Name}}</a></td>
        <td>{{property.Sequence}}</td>
        <ng-container [ngTemplateOutlet]="filterById" [ngTemplateOutletContext]="{value: property.GroupClv, items: classificatorValuesQuery.propertyGroups$}">
        </ng-container>
        <ng-container [ngTemplateOutlet]="filterById" [ngTemplateOutletContext]="{value: property.TypeClv, items: classificatorValuesQuery.propertyTypes$}">
        </ng-container>
        <ng-container [ngTemplateOutlet]="filterById" [ngTemplateOutletContext]="{value: property.ChoiceTypeClassificatorId, items: classificatorsQuery.getAll$}">
        </ng-container>
        <ng-container [ngTemplateOutlet]="filterById" [ngTemplateOutletContext]="{value: property.UnitId, items: unitService.getAll$}">
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
  <ng-template #filterById let-value="value" let-items="items">
    <td>
      <ng-container *ngIf="value">
        {{(items | async | find: ['Id'] : value)?.DisplayName}}
      </ng-container>
    </td>
  </ng-template>
</ng-container>
